import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Ratage from "./cv/Ratage";
import Avvvatars from 'avvvatars-react';
import { Eye, Search } from "lucide-react";

function Candidat(user) {
  const [idUser, setidUser] = useState(user.user.id);
  const [categorie, setCategorie] = useState('');
  const { id } = useParams();
  const [data, setData] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get("/cvs_page_search_status", {
          params: {
            page: currentPage,
            per_page: itemsPerPage,
            category_id: id,
            search: searchTerm,
            status: true,
          },
        });
        const cvs = response.data.cvs;
        setData(cvs);
        setTotalPages(response.data.total_pages);
      } catch (error) {
        console.error("Erreur lors de la récupération des données :", error);
      }
    };

    fetchData();
  }, [id, currentPage, itemsPerPage, searchTerm]); // Ajout de `id` dans les dépendances

  useEffect(() => {
    const fetchCategorie = async () => {
      try {
        const response = await axios.get(`categorie_cvs/${id}`);
        if (response.status === 200) {
          setCategorie(response.data.cat);
        }
      } catch (error) {
        console.log(error);
      }
    };

    if (id) {
      fetchCategorie();
    }
  }, [id]);

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  const renderPagination = () => {
    const pageNumbers = [];
    const maxPagesToShow = 5;
    let startPage = Math.max(1, currentPage - Math.floor(maxPagesToShow / 2));
    let endPage = startPage + maxPagesToShow - 1;

    if (endPage > totalPages) {
      endPage = totalPages;
      startPage = Math.max(1, endPage - maxPagesToShow + 1);
    }

    if (startPage > 1) {
      pageNumbers.push(
        <li key="1" className="paginate_button page-item" onClick={() => handlePageChange(1)}>
          <a href="#" className="page-link">1</a>
        </li>
      );
      if (startPage > 2) {
        pageNumbers.push(<li key="ellipsis-start" className="page-item disabled"><span className="page-link">...</span></li>);
      }
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <li key={i} className={`paginate_button page-item ${currentPage === i ? "active" : ""}`} onClick={() => handlePageChange(i)}>
          <a href="#" className="page-link">{i}</a>
        </li>
      );
    }

    if (endPage < totalPages) {
      if (endPage < totalPages - 1) {
        pageNumbers.push(<li key="ellipsis-end" className="page-item disabled"><span className="page-link">...</span></li>);
      }
      pageNumbers.push(
        <li key={totalPages} className="paginate_button page-item" onClick={() => handlePageChange(totalPages)}>
          <a href="#" className="page-link">{totalPages}</a>
        </li>
      );
    }

    return (
      <ul className="pagination">
        <li
          className={`paginate_button page-item previous ${currentPage === 1 ? "disabled" : ""}`}
          onClick={() => handlePageChange(currentPage - 1)}
        >
          <a href="#" className="page-link">Précédent</a>
        </li>
        {pageNumbers}
        <li
          className={`paginate_button page-item next ${currentPage === totalPages ? "disabled" : ""}`}
          onClick={() => handlePageChange(currentPage + 1)}
        >
          <a href="#" className="page-link">Suivant</a>
        </li>
      </ul>
    );
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(parseInt(e.target.value, 10));
    setCurrentPage(1);
  };

  return (
    <>
      <div className="adminx-content">
        <div className="adminx-main-content">
          <div className="container-fluid">
            <nav aria-label="breadcrumb" role="navigation">
              <ol className="breadcrumb adminx-page-breadcrumb">
                <li className="breadcrumb-item"><a href="/">Tableau de bord</a></li>
                <li className="breadcrumb-item"><a href="#">Candidats</a></li>
                <li className="breadcrumb-item active" aria-current="page">Tous les Candidats de {categorie.categorie} </li>
              </ol>
            </nav>

            <div className="pb-3">
              <h3>Candidats pour le post {categorie.categorie}</h3>
            </div>
            <div className="table-responsive-md">
              {data.length === 0 && (
                <div className="row">
                  <div className="col">
                    <div className="alert alert-warning" role="alert">
                      <strong>Aucun résultat</strong><br />
                      Aucun CV ne correspond à votre recherche.
                    </div>
                  </div>
                </div>
              )}
              <div className="row">
                <div className="col">
                  <div className="card mb-grid">
                    <div className="table-responsive-md">
                      <div className="dataTables_wrapper container-fluid dt-bootstrap4 no-footer">
                        <div className="row">
                          <div className="col-sm-12 col-md-6">
                            <div className="dataTables_length">
                              <label>
                                Montrer{" "}
                                <select
                                  value={itemsPerPage}
                                  onChange={handleItemsPerPageChange}
                                  className="form-control form-control-sm"
                                >
                                  <option value={10}>10</option>
                                  <option value={25}>25</option>
                                  <option value={50}>50</option>
                                  <option value={100}>100</option>
                                </select>{" "}
                                profils
                              </label>
                            </div>
                          </div>
                          <div className="col-sm-12 col-md-6">
                            <div className="dataTables_filter">
                              <label>
                                <Search size={16} strokeWidth={1.5} /> Recherche :
                                <input
                                  type="search"
                                  value={searchTerm}
                                  onChange={handleSearchChange}
                                  placeholder="Nom ou Prenom ..."
                                  className="form-control form-control-sm h31"
                                />
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-12">
                            <table className="table table-actions table-striped table-hover mb-0 dataTable no-footer">
                              <thead>
                                <tr>
                                  <th style={{ width: "93.1719px" }}></th>
                                  <th style={{ width: "320.828px" }}>ID</th>
                                  <th style={{ width: "311.062px" }}>Localisation</th>
                                  <th style={{ width: "303.719px" }}>Contrat</th>
                                  <th style={{ width: "303.719px" }}>Expérience</th>
                                  <th style={{ width: "402.984px" }}>Disponibilité</th>
                                  <th style={{ width: "402.984px" }}>Note</th>
                                  <th style={{ width: "103.234px" }}>Actions</th>
                                </tr>
                              </thead>
                              <tbody>
                                {data.map((profil) => {
                                  const image = profil.photo && profil.photo.url ? (
                                    <span>
                                      <Avvvatars size={50} value={profil.nomPrenom} />
                                    </span>
                                  ) : (
                                    <span
                                      style={{
                                        backgroundImage:
                                          "url(https://bootdey.com/img/Content/avatar/avatar6.png)",
                                      }}
                                      className="avatar avatar-xl mr-3"
                                    />
                                  );
                                  return (
                                    <tr key={profil.id}>
                                      <td>{image}</td>
                                      <th>
                                        <label className="custom-control custom-checkbox m-0 p-0">
                                          {profil.id}
                                          {!profil.status && (
                                            <span className="badge bg-warning ml-2">
                                              Brouillon
                                            </span>
                                          )}
                                        </label>
                                      </th>
                                      <td>
                                        <strong>{profil.nationalite}</strong>
                                      </td>
                                      <td>
                                        <span className="badge bg-info" style={{ color: '#fff' }}>
                                          {profil.contrat}
                                        </span>
                                      </td>
                                      <td>{profil.aExperience}</td>
                                      <td>
                                      {profil.disponibility === "Disponible immediat" ? (
                                        <span className="badge bg-success text-white">
                                          {profil.disponibility}
                                        </span>
                                      ) : profil.disponibility === "preavis" ? (
                                        <span className="badge bg-dark text-white">
                                          Disponible avec préavis
                                        </span>
                                      ) : profil.disponibility === "enposte" ? (
                                        <span className="badge bg-danger text-white">
                                          En poste
                                        </span>
                                      ) : (
                                        <span className="badge bg-light">
                                          {profil.disponibility}
                                        </span>
                                      )}
                                      </td>
                                      <td><Ratage dCv={profil} userId={idUser} /></td>
                                      <td>
                                        <div className="">
                                          &nbsp;&nbsp;
                                          <Link to={`/cv/${profil.id}`}>
                                            <button
                                              type="button"
                                              className="btn btn-info btn-sm"
                                              title="Voir le CV"
                                            >
                                              <Eye size={20} strokeWidth={1.5} /> Voir le CV
                                            </button>
                                          </Link>
                                        </div>
                                      </td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-12 col-md-5"></div>
                          <div className="col-sm-12 col-md-7">
                            {renderPagination()}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Candidat;
